angular.module( 'acme.view.application.orders.requests.modals.removeEvent', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.orders.requests.modals.removeEvent.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var ordersRequestsModalsRemoveEvent = {
        name: 'application.orders.requests.modals.removeEvent',
        url: '/orders/requests/modals/removeEvent',
        views: {
          "main": {
            controller: 'OrdersRequestsModalsRemoveEventController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/orders/requests/modals/removeEvent/removeEvent.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(ordersRequestsModalsRemoveEvent);
});
